import React from "react";
import styled from "styled-components";
import { FlexContainer } from "storybook-components/Container";
import { SubheadLg } from "storybook-components/Typography";

const StyledLinkWrapper = styled.a`
  display: flex;
  max-width: 420px;
  margin: auto;
  &:hover {
    path {
      fill: ${({ theme }) => theme.colors.green3};
    }
  }
`;

const StyledLinkText = styled(SubheadLg)`
  display: block;
  margin: 1rem auto;
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.green4};
  &:hover {
    color: ${({ theme }) => theme.colors.green3};
  }
`;

const ImageWrapper = styled.div`
  margin: auto 16px auto auto;
`;

export default ({ linkUrl, linkText }) => (
  <FlexContainer>
    <StyledLinkWrapper href={linkUrl} target="_blank">
      <ImageWrapper>
        <svg
          width="39"
          height="39"
          viewBox="0 0 39 39"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.4 1.15556V8.42256C10.4 10.338 11.1609 12.175 12.5153 13.5294C13.8698 14.8839 15.7068 15.6448 17.6222 15.6448H25.61C25.7132 15.6448 25.8122 15.6857 25.8853 15.7585C25.9584 15.8313 25.9996 15.9302 26 16.0333V17.2308C26 17.3342 25.9589 17.4334 25.8858 17.5065C25.8126 17.5797 25.7134 17.6208 25.61 17.6208H0.390003C0.338665 17.6208 0.287833 17.6309 0.240422 17.6506C0.19301 17.6703 0.149953 17.6992 0.113719 17.7355C0.0774853 17.7719 0.0487882 17.815 0.0292741 17.8625C0.00975986 17.91 -0.000187463 17.9609 2.67514e-06 18.0122V20.9878C2.67514e-06 21.0912 0.0410919 21.1904 0.114231 21.2635C0.18737 21.3367 0.286568 21.3778 0.390003 21.3778H25.61C25.7134 21.3778 25.8126 21.4189 25.8858 21.492C25.9589 21.5651 26 21.6643 26 21.7678V23.0432C26 23.1467 25.9589 23.2459 25.8858 23.319C25.8126 23.3921 25.7134 23.4332 25.61 23.4332H17.6222C15.7068 23.4332 13.8698 24.1941 12.5153 25.5486C11.1609 26.903 10.4 28.74 10.4 30.6554V37.8444C10.4 38.1509 10.5217 38.4448 10.7385 38.6615C10.9552 38.8783 11.2491 39 11.5556 39H27.4444C27.7509 39 28.0448 38.8783 28.2615 38.6615C28.4783 38.4448 28.6 38.1509 28.6 37.8444V29.6963C28.5998 28.528 28.8298 27.3711 29.2768 26.2916C29.7238 25.2122 30.3791 24.2314 31.2053 23.4053C32.0314 22.5791 33.0122 21.9238 34.0916 21.4768C35.1711 21.0298 36.328 20.7998 37.4963 20.8H38.61C38.7134 20.8 38.8126 20.7589 38.8858 20.6858C38.9589 20.6126 39 20.5134 39 20.41V18.59C39 18.4866 38.9589 18.3874 38.8858 18.3142C38.8126 18.2411 38.7134 18.2 38.61 18.2H37.4963C36.328 18.2002 35.1711 17.9702 34.0916 17.5232C33.0122 17.0762 32.0314 16.4209 31.2053 15.5947C30.3791 14.7686 29.7238 13.7878 29.2768 12.7084C28.8298 11.6289 28.5998 10.472 28.6 9.30367V1.15556C28.6 0.849083 28.4783 0.555163 28.2615 0.338454C28.0448 0.121746 27.7509 0 27.4444 0L11.5556 0C11.2491 0 10.9552 0.121746 10.7385 0.338454C10.5217 0.555163 10.4 0.849083 10.4 1.15556Z"
            fill="#2A6F2B"
          />
        </svg>
      </ImageWrapper>
      <StyledLinkText>{linkText}</StyledLinkText>
    </StyledLinkWrapper>
  </FlexContainer>
);
